import React, { useEffect, useState } from 'react'

import {
  About,
  Testimonial,
  Header,
  Work,
  Skill,
  Footer,
  StarsCanvas,
  Exprience,
} from '../utils/container'
import { Navbar } from '../utils/components'
import '../index.css'

import { UseGlobalContext } from '../Hooks/UseContext'
import MobileMenu from '../Components/Navbar/MobileMenu'
import ErrorBoundary from '../Hooks/ErrorBoundary'

const Home = () => {
  const [isloading, setIsloading] = useState(false)
  const { setIsSubMenuOpen } = UseGlobalContext()

  useEffect(() => {
    setTimeout(() => {
      setIsloading(false)
    }, 3000)
  })

  return (
    <>
      {isloading ? (
        <div className='dark:bg-primary bg-white text-center flex flex-col items-center justify-center w-screen h-screen'>
          <p className=' text-8xl blue_text'>jk;sdklnskf</p>
          <p className='text-md text-gray-500 absolute bottom-12 '>from</p>
          <h3 className='text-xl blue_text absolute bottom-6 font-extrabold '>
            @santus
          </h3>
        </div>
      ) : (
        <section
          className={`relative z-0 dark:bg-primary bg-primary_color`}
          onMouseOver={() => {
            setIsSubMenuOpen(false)
          }}
        >
          <section className='bg-cover bg-no-repeat bg-center ng-hero-pattern'>
            <Navbar />
            <Header />
          </section>
          <About />
          <Skill />
          <Exprience />
          <ErrorBoundary>
            <Work />
          </ErrorBoundary>
          <Testimonial />
          <section className=' relative'>
            <Footer />
            <StarsCanvas />
          </section>
        </section>
      )}
      <MobileMenu />
    </>
  )
}

export default Home
